import {
  GET_ACTIVATION_ANALYTICS_FIREBASE_EVENTS,
} from "../actions/types";

const initialState = {
  firebaseEvents: {},
};

const activationAnalyticsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_ACTIVATION_ANALYTICS_FIREBASE_EVENTS:
      return {
        ...state,
        firebaseEvents: payload,
      };
    default:
      return state;
  }
};

export default activationAnalyticsReducer;
